export default __webpack_public_path__ + "static/media/habibers-default.041e3a10.png";